

























































import { Component, Prop, Vue} from 'vue-property-decorator';
import Onboarding from '../apiClient/OnBoarding';
import PercentBars from '@/components/generics/PercentBars.vue';

interface ObStatistics {
    personalData: {
        items_obligatorios_completos: number,
        items_obligatorios_totales: number
    };
    documentData: {
        items_obligatorios_completos: number,
        items_obligatorios_totales: number
    };
    eformData: {
        items_obligatorios_completos: number,
        items_obligatorios_totales: number
    };
}

@Component({
  components: {
    PercentBars
  }
})
export default class Statistics extends Vue {
    @Prop() private obstats: ObStatistics;
    
    ob:Onboarding;

    get datos_personales () {
        return this.buildPercent(this.obstats.personalData.items_obligatorios_completos,this.obstats.personalData.items_obligatorios_totales)
    }

    get doc_personales () {
        return this.buildPercent(this.obstats.documentData.items_obligatorios_completos,this.obstats.documentData.items_obligatorios_totales)
    }

    get form_digitales () {
        return this.buildPercent(this.obstats.eformData.items_obligatorios_completos,this.obstats.eformData.items_obligatorios_totales)
    }

    buildPercent(completed,total){
        if(completed == 0 && total == 0){ return 0 }else { return (Math.round((completed) / (total)*100))}
    }
    
}
